export default __webpack_public_path__ + "static/media/longchamp27.e279030c.jpg";